module.exports = __webpack_public_path__ + "static/media/shangdianBuss.eca6421b.svg";